import React from 'react'
import { NotFound, Route } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'
import usePrisonAccess from '../../hooks/usePrisonAccess'

export default function PrisonAuthRoute({ children, ...rest }) {
  const { signedIn, userLoading } = useUser()
  const { accessFromPrison, isReady } = usePrisonAccess()

  if (isReady && accessFromPrison) {
    return <Route {...rest}>{children}</Route>
  }
  if (!signedIn && !userLoading) {
    window.location.replace(`/auth/familysearch/login?display=lite&returnUrl=${encodeURIComponent(window.location)}`)
  }

  if (isReady && !accessFromPrison) {
    return <NotFound />
  }

  return null
}
